import createIcon from '../../createIcon';

/**
 * @component @name Colorize
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNzA5IDUuNjMwNTVMMTguMzY5IDMuMjkwNTVDMTcuOTc5IDIuOTAwNTUgMTcuMzQ5IDIuOTAwNTUgMTYuOTU5IDMuMjkwNTVMMTMuODM5IDYuNDEwNTVMMTEuOTA5IDQuNTAwNTVMMTAuNDk5IDUuOTEwNTVMMTEuOTE5IDcuMzMwNTVMMi45OTkwMiAxNi4yNTA1VjIxLjAwMDVINy43NDkwMkwxNi42NjkgMTIuMDgwNUwxOC4wODkgMTMuNTAwNUwxOS40OTkgMTIuMDkwNUwxNy41NzkgMTAuMTcwNUwyMC42OTkgNy4wNTA1NUMyMS4wOTkgNi42NTA1NSAyMS4wOTkgNi4wMjA1NSAyMC43MDkgNS42MzA1NVpNNi45MTkwMiAxOS4wMDA1TDQuOTk5MDIgMTcuMDgwNUwxMy4wNTkgOS4wMjA1NUwxNC45NzkgMTAuOTQwNUw2LjkxOTAyIDE5LjAwMDVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Colorize = createIcon('Colorize', [
  [
    'path',
    {
      d: 'M20.709 5.63055L18.369 3.29055C17.979 2.90055 17.349 2.90055 16.959 3.29055L13.839 6.41055L11.909 4.50055L10.499 5.91055L11.919 7.33055L2.99902 16.2505V21.0005H7.74902L16.669 12.0805L18.089 13.5005L19.499 12.0905L17.579 10.1705L20.699 7.05055C21.099 6.65055 21.099 6.02055 20.709 5.63055ZM6.91902 19.0005L4.99902 17.0805L13.059 9.02055L14.979 10.9405L6.91902 19.0005Z',
      key: 'ypdh2i',
    },
  ],
]);

export default Colorize;
